import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getNotifications, markNotificationAsSeen, markNotificationsAsSeen, type GetNotificationsParams } from "./api";
import { useAuthStore } from "@/store/useAuthStore";

export function useNotifications(params: number | GetNotificationsParams = 1) {
  const token = useAuthStore((state) => state.token);

  const normalized: GetNotificationsParams =
    typeof params === "number" ? { page: params } : params;
  const { page = 1, limit = null, from = null, to = null } = normalized;

  return useQuery({
    // Include every filter in the key so changing a filter refetches.
    queryKey: ["notifications", page, limit, from, to],
    queryFn: () => getNotifications({ page, limit: limit ?? undefined, from, to }),
    staleTime: 60 * 1000, // 1 minute
    enabled: !!token,
  });
}

export function useMarkNotificationAsSeen() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => markNotificationAsSeen(id),
    onSuccess: () => {
      // Invalidate notifications query to refetch updated data
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}

/** «خواندن همه» — the unread notifications on screen, seen in one action; the inbox and the header tray re-read after. */
export function useMarkAllNotificationsAsSeen() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ids: number[]) => markNotificationsAsSeen(ids),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}
